module.exports = __webpack_public_path__ + "static/media/7.935c30ce.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/7.jpeg
// module id = 160
// module chunks = 0